import React from 'react';
import PropTypes from 'prop-types';
import { NamespaceConsumer, NamespaceShape, withNamespace } from '@ux/namespace-component';
import golfToEid from 'golf-to-eid';
import Link from '@ux/link';

export class LeftNavHeading extends NamespaceConsumer {
  /**
   * Renders category/subcat headings
   *
   * @returns {React.ReactElement} The rendered category heading
   * @private
   */
  render() {
    const {
      showSubCategory,
      split,
      categoryHref,
      categoryObj = {},
      subcategoryObj = {},
      activeCatBorder
    } = this.props;
    const eid = categoryObj.eid ||
      golfToEid(categoryObj.id || '', {
        prefix: 'uxp.hyd.sub_nav_category_' + split,
        postfix: 'link.click'
      });
    return (
      <div className={ this.namespace('left-sub-nav') }>
        {
          categoryHref ? <Link
            href={ categoryHref  }
            title={ categoryObj.title }
            id={ categoryObj.id }
            data-eid={ eid }
            className={ this.namespace(this.classNames('subnav-cat',
              'sub-nav-heading-link',
              { 'active-cat-border': activeCatBorder }
            )) }>
            { categoryObj.title }
          </Link> :
            <span className={ this.namespace('category-text') }>{ categoryObj.title }</span>
        }
        {
          showSubCategory && subcategoryObj.title && <span key={ subcategoryObj.id } className={ this.namespace('subnav-subcat-text') }>
            { ' / ' + subcategoryObj.title }
          </span>
        }
      </div>
    );
  }
}

LeftNavHeading.defaultProps = {
  showSubCategory: false
};

LeftNavHeading.propTypes = {
  ...NamespaceShape,
  activeCatBorder: PropTypes.bool,
  categoryHref: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ]),
  categoryObj: PropTypes.object,
  split: PropTypes.string,
  showSubCategory: PropTypes.bool,
  subcategoryObj: PropTypes.object
};

export default withNamespace(LeftNavHeading);
